import { useDataValue } from 'Simple/Data'
import { useMemo } from 'react'
import { REPORT_CONFIGURATIONS } from './helpers.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let current_location = useDataValue({
    context: 'global',
    path: 'current_location',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return REPORT_CONFIGURATIONS[props.type]({
      last_execution: data[0] || {},
      current_location,
      viewPath: props.viewPath,
    })
  }, [data, current_location, props.viewPath, props.type])
}
